import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import NotificationList from "../../components/NotificationList";
import { useEventPlannerPath } from "../../hooks/useEventPlannerPath";

const Notifications = () => {
  const navigate = useNavigate();
  const { basePath } = useEventPlannerPath();
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(basePath);
  };

  return (
    <main className="min-h-[100dvh] w-full bg-[#F9F9F9]">
      <header className="sticky top-0 z-20 flex min-h-[64px] items-center justify-between border-b border-[#E5E5E1] bg-[#F9F9F9]/95 px-4 pt-[env(safe-area-inset-top)] backdrop-blur md:min-h-[76px] md:px-8">
        <div className="w-10" aria-hidden="true" />
        <h1 className="optima text-[24px] font-[400] md:text-[30px]">Notifications</h1>
        <button
          type="button"
          onClick={goBack}
          aria-label="Close notifications"
          className="flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
        >
          <X size={20} strokeWidth={1.5} />
        </button>
      </header>
      <div className="mx-auto w-full max-w-4xl px-4 py-5 md:px-8 md:py-8">
        <div className="rounded-2xl border border-[#E5E5E1] bg-white p-3 md:p-5">
          <NotificationList limit={30} />
        </div>
      </div>
    </main>
  );
};

export default Notifications;
